import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./intro.css";

import introBgDesk from "./img/introbgdesk.png";
import introBgMob from "./img/introbgmob.png";

function Intro() {
  const navigate = useNavigate();

  const text = useMemo(
    () =>
      "An interactive game to encourage you to incorporate sustainability into Navratri celebrations at the office. Embark on this virtual journey where you / your team will navigate a series of challenges and tasks related to sustainable practices during the festival.",
    []
  );

  const [typed, setTyped] = useState("");
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [isNextClicked, setIsNextClicked] = useState(false);

  useEffect(() => {
    const body = document.body;
    const prev = {
      backgroundImage: body.style.backgroundImage,
      backgroundSize: body.style.backgroundSize,
      backgroundRepeat: body.style.backgroundRepeat,
      backgroundPosition: body.style.backgroundPosition,
      backgroundAttachment: body.style.backgroundAttachment,
    };

    const applyIntroBackground = () => {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      body.classList.remove("common-bg");
      body.style.backgroundImage = `url("${isMobile ? introBgMob : introBgDesk}")`;
      body.style.backgroundRepeat = "no-repeat";
      body.style.backgroundPosition = "center center";
      if (isMobile) {
        body.style.backgroundSize = "100% 100%";
        body.style.backgroundAttachment = "initial";
      } else {
        body.style.backgroundSize = "cover";
        body.style.backgroundAttachment = "fixed";
      }
    };

    applyIntroBackground();
    window.addEventListener("resize", applyIntroBackground);
    window.addEventListener("orientationchange", applyIntroBackground);

    let charIndex = 0;
    setTyped("");
    setIsTypingComplete(false);
    const intervalId = window.setInterval(() => {
      charIndex += 1;
      setTyped(text.slice(0, charIndex));
      if (charIndex >= text.length) {
        window.clearInterval(intervalId);
        setIsTypingComplete(true);
      }
    }, 30);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("resize", applyIntroBackground);
      window.removeEventListener("orientationchange", applyIntroBackground);
      body.style.backgroundImage = prev.backgroundImage;
      body.style.backgroundSize = prev.backgroundSize;
      body.style.backgroundRepeat = prev.backgroundRepeat;
      body.style.backgroundPosition = prev.backgroundPosition;
      body.style.backgroundAttachment = prev.backgroundAttachment;
    };
  }, [text]);

  const handleNext = () => {
    if (!isTypingComplete || isNextClicked) return;
    setIsNextClicked(true);
    navigate("/stage1", { replace: true });
  };

  return (
    <div className="intro-page">
      <div className="intro-container" id="intro-container">
        {typed}
      </div>

      <div className="intro-next-wrap">
        <button
          type="button"
          className="intro-next-btn"
          onClick={handleNext}
          disabled={!isTypingComplete}
        >
          Next
        </button>
      </div>

     
    </div>
  );
}

export default Intro;

